import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { translations } from './translations'

const STORAGE_KEY = 'mwuilu-lang'

const LanguageContext = createContext(null)

function readStoredLang() {
  try {
    const s = localStorage.getItem(STORAGE_KEY)
    if (s === 'en' || s === 'fr' || s === 'nl') return s
  } catch (_) {}
  return 'en'
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(readStoredLang)

  const setLang = useCallback((code) => {
    const next = code === 'fr' || code === 'nl' ? code : 'en'
    setLangState(next)
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch (_) {}
  }, [])

  const t = useCallback(
    (key, vars) => {
      const locale = lang === 'fr' || lang === 'nl' ? lang : 'en'
      const dict = translations[locale] || translations.en
      let str = dict[key] ?? translations.en[key] ?? key
      if (vars && typeof str === 'string') {
        Object.entries(vars).forEach(([k, v]) => {
          str = str.split(`{${k}}`).join(String(v))
        })
      }
      return str
    },
    [lang]
  )

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t])

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
}

export function useLanguage() {
  const ctx = useContext(LanguageContext)
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider')
  return ctx
}

/** Locale string for Date formatting (Belgium-focused). */
export function useDateLocale() {
  const { lang } = useLanguage()
  if (lang === 'fr') return 'fr-BE'
  if (lang === 'nl') return 'nl-BE'
  return 'en-GB'
}
